"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewSecretCommand = void 0;
const AbstractVariantCommand_1 = require("./AbstractVariantCommand");
class RenewSecretCommand extends AbstractVariantCommand_1.AbstractVariantCommand {
    constructor(api, appId, variantType, variantId) {
        super(api, appId);
        this.variantId = variantId;
        this.variantType = variantType;
    }
    async exec() {
        return (await this.api.put(`/applications/${this.appId}/${this.variantType}/${this.variantId}/reset`))
            .data;
    }
}
exports.RenewSecretCommand = RenewSecretCommand;
//# sourceMappingURL=RenewSecretCommand.js.map